import {FileInfo} from "../../interface/model/file";

export interface SurveyInfo {
    visitorInfoSeq:string,
    visitAreaDangerous:boolean | string,    // 위험지역방문여부
    visitAreas1?:string,      // 위험지역방문지
    visitAreas2?:string,      // 위험지역방문지
    visitAreas3?:string,      // 위험지역방문지
    /*temperature?:string         // 온도*/
    symptoms?:Array<string>,        // 증상들
}
export const constructSurveyInfo:SurveyInfo = {
    visitorInfoSeq:null,
    visitAreaDangerous:false,
    visitAreas1:'',      // 위험지역방문지
    visitAreas2:'',      // 위험지역방문지
    visitAreas3:'',      // 위험지역방문지
    symptoms: []
}

export interface StuffInfo {
    seq:number,
    category:string,
    serialNo:string,        // 시리얼번호
    purpose:string,         // 사용목적
    notice?:string,         // 특이사항
    sort:number
}
export const constructStuffInfo:StuffInfo = {
    seq:null,
    category:'',
    serialNo:'',
    purpose:'',
    sort:null
}

export interface EquipmentInfo {
    seq:number,
    fileInfos:Array<FileInfo>
}
export const constructEquipmentInfo:EquipmentInfo = {
    seq:null,
    fileInfos:[]
}

export interface CertificateInfo {
    visitorInfoSeq:string,
    seq:number,
    certificateDate:string,
    fileInfos:Array<FileInfo>
}
export const constructCertificateInfo:CertificateInfo = {
    visitorInfoSeq:null,
    seq: null,
    certificateDate:null,
    fileInfos:[]
}

export interface PledgeInfo {

}
export const constructPledgeInfo:PledgeInfo = {

}
